/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigGarantieItemDto } from './ConfigGarantieItemDto';
import {
    ConfigGarantieItemDtoFromJSON,
    ConfigGarantieItemDtoFromJSONTyped,
    ConfigGarantieItemDtoToJSON,
    ConfigGarantieItemDtoToJSONTyped,
} from './ConfigGarantieItemDto';

/**
 * 
 * @export
 * @interface ParcConfigDto
 */
export interface ParcConfigDto {
    /**
     * Biens écartés de la couverture à l'étape dossier location (réintégrables par checkbox)
     * @type {Array<string>}
     * @memberof ParcConfigDto
     */
    biensExclus?: Array<string>;
    /**
     * Biens éligibles retenus dans le contrat parc
     * @type {Array<string>}
     * @memberof ParcConfigDto
     */
    biensInclus: Array<string>;
    /**
     * Couverture appliquée à tous les biens inclus
     * @type {Array<ConfigGarantieItemDto>}
     * @memberof ParcConfigDto
     */
    global: Array<ConfigGarantieItemDto>;
    /**
     * Dérogations par bien (bienImmobilierId -> items)
     * @type {{ [key: string]: Array<ConfigGarantieItemDto>; }}
     * @memberof ParcConfigDto
     */
    overrides: { [key: string]: Array<ConfigGarantieItemDto>; };
}

/**
 * Check if a given object implements the ParcConfigDto interface.
 */
export function instanceOfParcConfigDto(value: object): value is ParcConfigDto {
    if (!('biensInclus' in value) || value['biensInclus'] === undefined) return false;
    if (!('global' in value) || value['global'] === undefined) return false;
    if (!('overrides' in value) || value['overrides'] === undefined) return false;
    return true;
}

export function ParcConfigDtoFromJSON(json: any): ParcConfigDto {
    return ParcConfigDtoFromJSONTyped(json, false);
}

export function ParcConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'biensExclus': json['biensExclus'] == null ? undefined : json['biensExclus'],
        'biensInclus': json['biensInclus'],
        'global': ((json['global'] as Array<any>).map(ConfigGarantieItemDtoFromJSON)),
        'overrides': json['overrides'],
    };
}

export function ParcConfigDtoToJSON(json: any): ParcConfigDto {
    return ParcConfigDtoToJSONTyped(json, false);
}

export function ParcConfigDtoToJSONTyped(value?: ParcConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'biensExclus': value['biensExclus'],
        'biensInclus': value['biensInclus'],
        'global': ((value['global'] as Array<any>).map(ConfigGarantieItemDtoToJSON)),
        'overrides': value['overrides'],
    };
}

